module.exports = __webpack_public_path__ + "img/romain-thanh-thanh.4e49948.jpg";